var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-list-item go-loading-card",
      attrs: { "data-template": "list-loading" },
    },
    [
      _c("div", { staticClass: "go-card-main" }, [
        _c("div", { staticClass: "go-card-body" }, [
          _c("div", { staticClass: "go-icon-wrap" }, [
            _c("div", { staticClass: "go-animation go-loader-animation" }, [
              _c(
                "svg",
                {
                  staticClass: "go-loader-svg",
                  attrs: { viewBox: "0 0 50 50" },
                },
                [
                  _c("circle", {
                    staticClass: "loader-circle bg",
                    attrs: { cx: "25", cy: "25", r: "23" },
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    staticClass: "loader-circle animate",
                    attrs: { cx: "25", cy: "25", r: "23" },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }